import React, { CSSProperties, useState } from "react";
import { useMediaQuery } from 'react-responsive';
import VisibilitySensor from 'react-visibility-sensor'

import {
  connectInfiniteHits,
  connectStateResults,
} from "react-instantsearch-dom";
import {
  InfiniteHitsProvided,
  StateResultsProvided,
} from "react-instantsearch-core";
import * as classes from "./ProductContainer.module.css";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { ProductCard } from "../lib/ProductCard";
import { Advert } from "./Advert";
type ProductContainerProps = InfiniteHitsProvided<any> & StateResultsProvided;
 
export const ProductContainer = connectInfiniteHits(
  connectStateResults<ProductContainerProps>(
    ({
      hits,
      hasPrevious,
      hasMore,
      refineNext,
      refinePrevious,
      isSearchStalled,
      searchResults,
      adverts,
      hitsPerPage = 48
    }) => {

      const isDesktopViewport = useMediaQuery({ query: '(min-width: 768px)' });
      
      const searchIndex = searchResults?.index;
      const queryID = (searchResults as any)?.queryID;

      
      
      React.useEffect(() => {

        if (queryID) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            queryID,
            searchIndex,
          });

          const value = window.localStorage.getItem("algolia-insights");
          let json;
          try {
            json = JSON.parse(value);
            json.queries.push({
              queryID,
              searchIndex,
            });
          } catch (error) {
            json = {
              products: {},
              queries: [
                {
                  queryID,
                  searchIndex,
                },
              ],
            };
          }
          window.localStorage.setItem("algolia-insights", JSON.stringify(json));
        }
        

      }, [queryID, searchIndex]);

      if (!hits.length && !isSearchStalled) {
        return null;
      }

      const handleBackToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      };

      //Check if Load More Checker is in view
      function onVisibilityChange (isVisible) {
        if(isVisible){
          refineNext()
        }
      }

      let cardCountStarted = false;
      let cardCount = 0;
      const cardCountUpdate = () => {
        cardCount = cardCount + 1
      }
      const resetCardCount = () => {
        cardCount = 0
      }

      let advertCount = 0;
      const updateAdvertCount = () => {
        advertCount = advertCount + 1
        // if(adverts[advertCount + 1] !== undefined) // if there is another advert, up count.
        //   advertCount = advertCount + 1
        // else // If there is no more adverts, loop back to start.
          /// resetAdvertCount()
      } 
      const resetAdvertCount = () => {
        advertCount = 0
      }

      const advertExists = (key) => {
        return adverts && adverts[key] !== undefined
      }
      
      let lastAdvertWasLarge = false;
      const advertPositions = (currentPosition, advert) => {
        let found = false
        let isLargeAdvert = advert.creative.aspect_ratio > 1;
        
        // If ad service has been started.
        // Add advert cards to the left and right.
        if(cardCountStarted){
          if(cardCount == 4){
            found = true
            cardCountUpdate()
          }else if(
            isLargeAdvert && cardCount == 14 //For larger ads.
            ||
            cardCount == 15
          ){ 
            found = true  
            resetCardCount() // Reset cardCount to add adverts to the left and right again.
          }
        }

        // Start the ad service.
        if(
          cardCount == 6 && isLargeAdvert && !cardCountStarted // For larger ads.
          ||
          currentPosition == 7 && !cardCountStarted
        ) {
          found = true
          cardCountStarted = true
          resetCardCount()
        }

        lastAdvertWasLarge = isLargeAdvert;

        return found
      }

      const LoadingButton = () => {
        return (
          <button
            className={clsx("button", "button--contained")}
          >
            Loading...
          </button>
        )
      }

      return (
        <div className={clsx(classes.root + ' product-cards')}>

          {/* {isDesktopViewport && hasPrevious && ( */}
          {hasPrevious && (
            <div className={classes.buttons + ' load-prev-buttons'}>
              <>
                {isSearchStalled ? (
                  <LoadingButton/>
                ):(
                  <button
                    className={clsx("button", "button--contained")}
                    onClick={() => {
                      refinePrevious();
                    }}
                  >
                    Load previous
                  </button>  
                )} 
              </>
            </div> 
          )}

          <div className={classes.grid}> 
            {/* {hits.length === 0 || isSearchStalled ? ( */}
            {/* {hits.length === 0 && isSearchStalled || isDesktopViewport && (hits.length === 0 || isSearchStalled) ? ( */}
            {hits.length === 0 && isSearchStalled ? (
              Array.from({ length: 36 }, (_, i) => (
                <ProductCard.Skeleton key={i} /> 
              ))
            ) : (  
              <> 
                {hits.map((hit, i) => ( 
                  <>

                    {advertExists(advertCount) && advertPositions(i, adverts[advertCount]) && (
                      <> 
                        <div key={i} 
                          className={clsx(classes.advert + ' advert', {
                          [classes.large]: adverts[advertCount].creative.aspect_ratio > 1 })
                        }>
                          <Advert advert={adverts[advertCount]} slot={i} />
                        </div>
                        {updateAdvertCount()}
                      </>
                    )}

                    <ProductCard 
                      key={hit.objectID}
                      hit={hit}
                    />

                    {cardCountUpdate()}
                    
                  </>
                ))}
              </>
            )}
          </div>

          {/* {isDesktopViewport && searchResults && ( */}
          {searchResults && (
            <div className={classes.progress + " progress"}>
              <p>
                <b>{Math.max(hits.length, searchResults.page * hitsPerPage)}</b>{" "}
                out of <b>{searchResults.nbHits}</b> products
              </p>
              <div className={classes.progressWrapper}>
                <div
                  className={classes.progressBar}
                  style={{
                    transform: `translateX(${Math.min(
                      0,
                      -100 *
                        (1 -
                          Math.max(
                            hits.length,
                            searchResults.page * hitsPerPage
                          ) /
                            searchResults.nbHits)
                    )}%)`,
                  }}
                ></div>
              </div>
            </div> 
          )}
          
          {/* {!isDesktopViewport && hasMore && (  
            <VisibilitySensor partialVisibility={true} onChange={onVisibilityChange}>
              <div className="LoadMoreChecker"></div> 
            </VisibilitySensor>
          )} */}

          {/* {isDesktopViewport && ( */}
            <div className={classes.buttons + " load-more-buttons"}>
              {hasMore && (
                <>
                  {isSearchStalled ? (
                    <LoadingButton/>
                  ):(
                    <button
                      className={clsx("button", "button--contained")}
                      onClick={() => {
                        refineNext();
                      }}
                    >
                      Load more
                    </button>
                  )}
                </>
              )}
              <button
                className={clsx("icon-button", "icon-button--outlined")}
                aria-label="back to top"
                onClick={handleBackToTop}
              >
                <FontAwesomeIcon icon={faChevronUp} width={14} height={14} />
              </button>
            </div>
          {/* )} */}

        </div>
      );
    }
  )
);
